import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { useSettingsContext } from '../../contexts/settings';

const Default = ({ post }) => {
	const settings = useSettingsContext();
	const date = new Date(post.post_date);
	const monthNames = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	const dateString = monthNames[date.getMonth()] + ' ' + date.getFullYear();

	let linkText = 'Read More';
	if ('video' === post.post_type || 'webinar' === post.post_type) {
		linkText = 'Watch Now';
	}
	return (
		<div className="col-lg-4">
			<a href={post.permalink} className="card-news-events">
				{!settings.hideImages && (
					<figure
						className="pfa-card-default__img-wrapper"
						dangerouslySetInnerHTML={{ __html: post.featured_image }}
					/>
				)}
				<time>
					{post.post_type} / {dateString}
				</time>
				<h6 dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }} />
				<span>{linkText}</span>
			</a>
		</div>
	);
};

Default.displayName = 'Default';

export default Default;
